import React from 'react'
import {Icon} from '@chakra-ui/react'

const ChevronUp = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props} data-testid="chevron-up">
            <path
                id="arrow"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.93945 25.9393L8.06077 28.0606L20.0001 16.1213L31.9395 28.0606L34.0608 25.9393L20.0001 11.8787L5.93945 25.9393Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default ChevronUp
